var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn--pill pill",class:{
    [`pill--${_vm.size}`]: !!_vm.size,
    [`pill--${_vm.thickness}`]: !!_vm.thickness,
    [_vm.color]: true,
    'btn--disabled': _vm.disabled,
    'btn--fill': _vm.fill
  },attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.onClick($event)}}},[(!_vm.isLoading)?[_vm._t("default")]:[_c('span',{staticClass:"spinner-border spinner-border-sm",attrs:{"role":"status","aria-hidden":"true"}}),_vm._v("\n    請稍候\n  ")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }